import * as React from 'react';

interface GpsButtonProps {
  onClick: () => void;
  isLoading: boolean;
  disabled?: boolean;
  error?: string | null;
}

export function GpsButton({ onClick, isLoading, disabled = false, error }: GpsButtonProps) {
  const isDisabled = disabled || isLoading;

  return (
    <div className="mb-6">
      <button
        type="button"
        onClick={onClick}
        disabled={isDisabled}
        className={`inline-flex items-center gap-2.5 px-6 py-3 text-base font-semibold rounded-lg transition-all duration-200 ${
          isDisabled
            ? 'bg-gray-200 text-gray-500 cursor-not-allowed'
            : 'bg-gradient-to-br from-green-500 to-green-600 text-white hover:from-green-600 hover:to-green-700 shadow-md hover:shadow-lg'
        }`}
        aria-busy={isLoading}
        aria-describedby={error ? 'gps-error' : undefined}
      >
        {isLoading ? (
          <>
            <svg className="w-5 h-5 animate-spin" viewBox="0 0 24 24" aria-hidden="true">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
            </svg>
            <span>Buscando ubicacion...</span>
          </>
        ) : (
          <>
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>
            <span>Usar mi ubicacion</span>
          </>
        )}
      </button>

      {error && (
        <p id="gps-error" className="mt-3 text-sm text-red-600" role="alert">
          {error}
        </p>
      )}

      <p className="mt-3 text-sm text-gray-500">
        Detectaremos automaticamente tu direccion usando GPS
      </p>
    </div>
  );
}
